import Swal from 'sweetalert2';
window.Swal = Swal;
let alerts = {
    success: function (response) {
        return new Promise((resolve) => {
            window.Swal.fire({
                icon: 'success',
                text: response.data.message,
                showConfirmButton: true,
                padding: '20px',
            }).then((e) => {
				console.log(e);
                resolve(response);
            });
        })
    },
    successMessage: function (message) {
        return new Promise(() => {
            window.Swal.fire({
                icon: 'success',
                text: message,
                showConfirmButton: true,
                padding: '20px',
            })
        });
    },
    errorMessage: function (message) {
        return new Promise(() => {
            window.Swal.fire({
                icon: 'error',
                text: message,
                showConfirmButton: true,
                padding: '20px',
            })
        });
    },
    warning: function (response) {
        return new Promise((resolve) => {
            window.Swal.fire({
                icon: 'warning',
                title: response.data.message,
                showConfirmButton: false,
                padding: '20px',
                timer: 2000
			}).then((e) => {
				console.log(e);
                resolve(response);
            });
        });
    },
    error: function (response) {
        return new Promise((resolve) => {
            window.Swal.fire({
                icon: 'error',
                title: response.data.message,
                padding: '20px',
                showConfirmButton: true,
			}).then((e) => {
				console.log(e);
                resolve(response);
            });
        });
    },
    formError: function (response) {
        return new Promise((resolve) => {
            window.Swal.fire({
                icon: 'error',
                title: response.message,
                padding: '20px',
                showConfirmButton: true,
			}).then((e) => {
				console.log(e);
                resolve(response);
            });
        });
    }
};

window.alerts = alerts;
